import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { BaseServiceService } from 'src/app/services/base-service.service';
import { ModalNotifyComponent, ModalNotifyTypes } from '../modal-notify/modal-notify.component';
import { DataTableComponent } from '../controls/data-table/data-table.component';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

declare var fabric: any;

@Component({
  selector: 'app-rol',
  templateUrl: './rol.component.html',
  styleUrl: './rol.component.css'
})
export class RolComponent implements OnInit{
  @ViewChild(DataTableComponent) dataTableComponent!: DataTableComponent;
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  dialogComponentCreate: any;
  dialogComponentEdit: any;
  formSubmitted: boolean = false;
  botonProcesando = false;
  textoBotonProcesando = 'Cargando...';
  idRol: any;
  roleForm: FormGroup;
  rolObj : Rol;

  @ViewChild(DataTableDirective, { static: false })

  dtElement: any;
  dtInstance: DataTables.Api;

  dtOptions: DataTables.Settings = {};
  dtOptButtons: any = [];
  response: any[] = [];
  titulo: string = '';
  internalDescription: string = '';
  dtTrigger: any;
  valorCompartido: any;
  validateDel: boolean = false;
  getDataTableRol: any = ["RolUsuario","GetDataTableRolUsuario"];
  
  booleanColumnRenderer = (data: any, type: any, row: any, meta: any) => {
    if (type === 'display') {
      return `<input type="checkbox" disabled ${data ? 'checked' : ''}>`;
    }
    return data;
  };


  columnas = [
    { title: 'Rol', data: 'NombreRol' },
    { title: 'Descripcion', data: 'Descripcion' },
    { title: 'Activo', data: 'Activo', render: this.booleanColumnRenderer, orderable : false },
    { title: 'Todos Procesos', data: 'TodosProcesos', render: this.booleanColumnRenderer, orderable : false },
    
  ];

  constructor(
    private baseService : BaseServiceService,
    private renderer: Renderer2,
    private http: HttpClient,
    private _formBuilder:FormBuilder

  ){
    this.rolObj = new Rol();
    this.formInit();
  }
/* Datatable */

  async ngOnInit(): Promise<void> {
    this.baseService.abrirModalEditar$.subscribe(() => {
      this.abrirModalEditar();
    }); 

    this.dtOptButtons.push({'button-id': 'btnEdit', 'button-icon': 'ms-Icon--EditNote', "button-tooltip": "Editar" }, 
      /* {'button-id': 'btnDelete', 'button-icon': 'ms-Icon--Delete'} */)

    var SpinnerElements = document.querySelectorAll('.ms-Spinner');
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric['Spinner'](SpinnerElements[i]);
    }
  }
  
  ngAfterViewInit(): void {
  }
  
  ngOnDestroy(): void {
    // Destroy the DataTables when the component is destroyed to prevent memory leaks
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.off('draw');
      });
    }
  }

  formInit()
  {
    this.roleForm = this._formBuilder.group({
      NombreRol: new FormControl('', [Validators.required ]),
      Descripcion: new FormControl('', [Validators.required]),
      Activo: new FormControl(false),
      TodosProcesos: new FormControl(false)
    });
  }
  
  
  gridLoaded(event: any)
  {
    this.dtInstance = event['table'];
  }

  customClick(event: any)
  {
    try {
      
      this.idRol = event["data-id"];

      switch(event['button-id'])
      {
        case 'btnEdit':
          this.abrirModalEditar();
          break;
        case 'btnDelete':
          this.delete();
          break;
      }
      
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  delete() {
    try {
      // Llamamos a triggerShowModal para abrir el modal de confirmación
      this.baseService.triggerShowModal('Eliminar Rol', '¿Seguro que desea eliminar el Rol?', ModalNotifyTypes.Warning, true);
  
      // Manejamos el evento actionConfirmed del ModalNotifyComponent
      this.modalNotifyComponent.actionConfirmed.subscribe((confirmed: boolean) => {
        if (confirmed) {
          // Si se confirma la eliminación, procedemos con la llamada a la API para eliminar
          this.baseService.delete('RolUsuario/BorrarRol', this.idRol).then(() => {
            this.reloadDataTable();
            this.baseService.triggerShowModal('Rol Eliminado', 'Rol Eliminado Correctamente', ModalNotifyTypes.Success, false);
          });
        } else {
          // Si se cancela la eliminación, no hacemos nada
        }
      });
    } catch (error: any) {
      this.baseService.triggerShowModal('Error al enviar el formulario:', error, ModalNotifyTypes.Danger, false);
    }
  }
  

  reloadDataTable(): void {
    // Obtener la instancia de DataTable y recargar los datos

      this.dtInstance.ajax.reload(null, false); // false para mantener la página actual después de la recarga

  }
  
/* Fin Datatable */
 
   async abrirModalEditar() {
    try {
      
      if (this.idRol !== null) {
        const responseById = await this.baseService.getById(
          'RolUsuario/GetRol',
          this.idRol
        );
        if (responseById.Data) {
          
          const Data = responseById.Data;
          this.roleForm.controls['NombreRol'].setValue(Data.NombreRol);
          this.roleForm.controls['Descripcion'].setValue(Data.Descripcion);
          this.roleForm.controls['Activo'].setValue(Data.Activo);
          this.roleForm.controls['TodosProcesos'].setValue(Data.TodosProcesos);
          // this.rolObj.NombreRol = Data.NombreRol;
          
          // this.rolObj.Descripcion = Data.Descripcion;
          // this.rolObj.Activo = Data.Activo;

          $('#dialogCreateEdit').html('Editar Rol');
          $('#btnCreateEdit > span').html('Actualizar');

          const selectedOption =
            document.querySelectorAll('.ms-Dropdown-title');

          selectedOption.forEach((selected) => {
            const fieldNameElement = selected.parentNode as HTMLElement;
            const dropdownSelect = fieldNameElement.querySelector(
              '.ms-Dropdown-select'
            );
            const fieldName = dropdownSelect?.getAttribute('name');
            const fieldValue = fieldName ? Data[fieldName] : null;
            if (fieldValue) {
              selected.textContent = fieldValue;
            }
          });

          const dialog = document.querySelector('.create-rol');
      
          this.dialogComponentCreate = new fabric['Dialog'](dialog);
          this.dialogComponentCreate.open();
        } else {
          /* this.baseService.triggerShowModal(
            'Error',
            'Error al cargar los datos del Tenant con ID: ' + this.id,
            ModalNotifyTypes.Danger
          ); */
        }
      }
    } catch (error: any) {
      this.baseService.triggerShowModal(
        'Error',
        error.Error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }


   async editarRol() {
    this.validateRol();
    if (this.validateRol()) {
      try {

        const responseUpdateTenant = await this.baseService.update(
          'RolUsuario/ActualizarRol',
          this.idRol,
          this.rolObj
        );
        // this.rolObj

        
        if (!responseUpdateTenant.Ok) {
          this.dialogComponentEdit.close();

          let mensajeError = '<ul>';
          responseUpdateTenant.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += '</ul>';

          this.baseService.triggerShowModal(
            'Error al editar Rol',
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentEdit.close();
          this.baseService.triggerShowModal(
            'Rol Editado',
            'Se ha almacenado el registro correctamente ',
            ModalNotifyTypes.Success,
            false
          );
          this.botonProcesando = false;
          this.reloadDataTable();
        }
      } catch (error: any) {
        this.dialogComponentEdit.close();
        let mensajeError = '<ul>';
        error.error.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += '</ul>';
        
        this.baseService.triggerShowModal(
          'Error al editar Rol',
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );      }
    }

  }



   invalidField(fieldName: string): boolean {
    const fieldValue = this.rolObj[fieldName as keyof Rol];

    // Verificar si el campo está definido y no es nulo
    if (fieldValue !== undefined && fieldValue !== null) {
        // Si es un string, verificar si está vacío o solo contiene espacios en blanco
        if (typeof fieldValue === 'string') {
            return this.formSubmitted && (!fieldValue.trim());
        }
        // Si es un número, verificar si es NaN (Not a Number)
        else if (typeof fieldValue === 'number') {
            return this.formSubmitted && isNaN(fieldValue);
        }
        // Otros tipos de datos no se consideran inválidos
        else {
            return false;
        }
    }
    // Si el campo es undefined o null, considerarlo inválido
    else {
        return this.formSubmitted;
    }
}

  validateRol() {
    this.formSubmitted = true;
    return ![
      'NombreRol',
      'Descripcion',
    ].some((field) => this.invalidField(field));
  }



  abrirModalCrear() {
    this.clearFormRolCreado();
    $('#dialogCreateEdit').html('Crear Rol');
    $('#btnCreateEdit > span').html('Crear');
    this.roleForm.controls["Activo"].setValue(true);

    const dialog = document.querySelector('.create-rol');
    this.dialogComponentCreate = new fabric['Dialog'](dialog);
    this.dialogComponentCreate.open();
  }




  async crearEditarRol() {
    // this.validateRol();
    // if (this.validateRol()) {
      this.botonProcesando = true;
      this.rolObj.NombreRol = this.roleForm.get('NombreRol').value;
      this.rolObj.Descripcion = this.roleForm.get('Descripcion').value;
      this.rolObj.Activo = this.roleForm.get('Activo').value;
      this.rolObj.TodosProcesos = this.roleForm.get('TodosProcesos').value;
      this.rolObj.TodasTareas = true;
      this.rolObj.TodosFormularios = true;
      
      
      try {
        if(this.idRol)
        {
          const response = await this.baseService.update(
            'RolUsuario/ActualizarRol',
            this.idRol,
            this.rolObj
          );
          
          if (!response.Ok) {
            this.dialogComponentEdit.close();
  
            let mensajeError = '<ul>';
            response.ValidationErrors.forEach((error: any) => {
              mensajeError += `<li>${error}</li>`;
            });
            mensajeError += '</ul>';
  
            this.baseService.triggerShowModal(
              'Error al editar Rol',
              mensajeError,
              ModalNotifyTypes.Danger,
              false
            );
          } else {
            this.dialogComponentCreate.close();
            this.baseService.triggerShowModal(
              'Rol Editado',
              'Se ha almacenado el registro correctamente ',
              ModalNotifyTypes.Success,
              false
            );
          }
        }
        else
        {
          const response = await this.baseService.create(
            'RolUsuario/CrearRol',
            this.rolObj
          );
  
          if (!response.Ok) {
            this.dialogComponentCreate.close();
  
            let mensajeError = '<ul>';
            response.ValidationErrors.forEach((error: any) => {
              mensajeError += `<li>${error}</li>`;
            });
            mensajeError += '</ul>';
  
            this.baseService.triggerShowModal(
              'Error al crear Rol',
              mensajeError,
              ModalNotifyTypes.Danger,
              false
            );
          } else {
            this.dialogComponentCreate.close();
            this.baseService.triggerShowModal(
              'Rol Creado',
              'Se ha almacenado el registro correctamente ',
              ModalNotifyTypes.Success,
              false
            );
          }
        }

        this.botonProcesando = false;
        this.reloadDataTable();
        //this.clearFormRolCreado();
        
      } catch (error:any) {

        this.dialogComponentCreate.close();

        let mensajeError = error.error.Error;
        
        this.baseService.triggerShowModal(
          "Error",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      }
    // } else {
    //   this.botonProcesando = false;

    // }
  }
  clearFormRol() {

    this.baseService.triggerShowModal(
      "Cancelar creacion de Rol",
      "¿Seguro que desea cancelar la creacion del rol?",
      ModalNotifyTypes.Warning,
      true
    );

    //this.baseService.clearForm();

    this.modalNotifyComponent.actionConfirmed.subscribe(
      (confirmed: boolean) => {
        if (confirmed) {
          this.rolObj = new Rol();
          this.roleForm.reset();
          this.idRol = null;
          this.dialogComponentCreate.close();

         
        } else {
          // Si se cancela la eliminación, no hacemos nada
        }
      }
    );
  }

  clearFormRolCreado() {
    this.rolObj = new Rol();
    this.roleForm.reset();
    this.idRol = null;
    //this.baseService.clearForm();
  }

}


export class Rol {
  NombreRol:string
  Descripcion:string
  Configuracion:string
  TodosProcesos:boolean
  TodosFormularios:boolean
  TodasTareas:boolean
  Activo:boolean

  constructor(){
    this.NombreRol = '';
    this.Descripcion = '';
    this.Configuracion = '';
    this.TodosProcesos = undefined;
    this.TodosFormularios = undefined;
    this.TodasTareas = undefined;
    this.Activo = undefined;
  }
}